<template>
    <div class="">
            <!-- 头部 -->
            <div class="header">
                <div class="header-left">
                    <div></div>
                </div>
                <div class="header-center" style="width:33.33%;">
                    <p>微信支付</p>
                </div>
                <div class="header-right">
                    <div style="width:50px;display: flex;justify-content: flex-end;" @click="toHome">
                        <span class="iconfont iconshouye" style="font-size:20px;"></span>
                    </div> 
                </div>
            </div>
            
            <!-- logo -->
            <div class="logo">
                <img src="../../assets/img/icon.png" alt="">
                <div>支付成功</div>
            </div>
            <!-- 订单详情 -->
            <div class="orderOut" v-if="isShow">    
                <div class="orderInner">
                    <div class="innerHeader">
                        <div class="headerText">单号：{{Data.BillCode}}</div>
                    </div>
                    <div class="innerContent">
                        <p>服务项目：{{Data.ServiceName}}</p>
                        <p>服务地址：{{Data.CustomerAddress}}</p>
                        <p>联系人：{{Data.CustomerName}} {{Data.CustomerPhone}}</p>
                        <p>订单总金额：￥{{Data.Amount}}</p>
                        <p>已服务金额：￥{{Data.ReturnAmount}}</p>
                        <p>已付金额：￥{{Data.PayAmount}}</p>
                        <p>未付金额：￥{{Data.UnPayAmount}}</p>
                        <p>可付金额：￥{{Data.CanPayAmount}}</p>
                    </div>

                </div>
            </div>
         <!-- 完成按钮 -->
            <div class="finishedBtn">
                <div class="listBtn" @click="toList">订单列表</div>
                <div class="indexBtn" @click="toHome">返回首页</div>
            </div>
            <!-- loading -->
            <div class="loading" v-if="!isShow">
                <van-loading color="#1989fa" size="60px"/>
            </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            OrderId:'',
            Data: {},
            isShow:false
        }
    },
    created(){
        this.OrderId = this.$route.query.Id
        this.getData()
    },
    methods:{
        getData(){
            let id = this.$route.query.Id
            this.$axios.get('/api/DjOrder/GetOrderInfoForPay',{
                params: {
                    Id:this.OrderId
                }
            }).then(res => {
                this.Data = res.data
                this.isShow = true
            })
        },
        toHome(){
            this.$router.replace("/")
        },
        toList(){
            this.$router.replace("/orderlist")
        }
    }
}
</script>

<style scoped>
.header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    background: #009933;
    color: white;
}
.header-center{
   display: flex;
   justify-content: center;
   align-items: center; 
}

.header-left {
    margin-left: 5px;
    width: 33.33%;
}

.header-right {
    margin-right: 5px;
    width: 33.33%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center; 
}
.finishedBtn{
    display: flex;
    padding: 8px;
    margin-top: 24px;
}
.listBtn{
    width: 50%;
    height: 36px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    background-color: #04be02;
    color: white;
    margin-right: 4px;
}
.indexBtn{
    width: 50%;
    height: 36px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    background-color: #ffb400;
    color: white;
    margin-left: 4px;
}
.logo{
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
}
.logo>img{
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
}
.orderOut{
    width: 100%;
    padding: 10px 6px;
    box-sizing: border-box;
    margin-top: 12px;
}
.orderTime{
    font-size: 13px;
    margin-bottom: 4px;
    color: #999999;
}
.orderInner{
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    background-color: white;
}
.innerHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    font-size: 13px;
    padding: 6px 6px;
    color: #999;
}
.order-status-tips{
    background-color: #578EBE;
    color: #fff;
    height: 20px;
    width: 56px;
    margin-left: -6px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
}
.innerContent{
    padding: 8px;
    position: relative;
    min-height: 88px;
}
.innerContent>p{
    line-height: 24px;
    font-size: 13px;
}
.loading{
    width: 300px;
    height: 300px;
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
    display: flex;
    justify-content: center;
    align-items: center;
}           
</style>



// WEBPACK FOOTER //
// src/pages/FinishedPay/FinishedPay.vue